import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';

const dsn = process.env.REACT_APP_SENTRY_DSN?.trim();
const isProd = process.env.NODE_ENV === 'production';

export function initSentry(): void {
  if (!dsn) {
    return;
  }

  Sentry.init({
    dsn,
    sendDefaultPii: false,
    environment: isProd ? 'production' : 'development',
    release: process.env.REACT_APP_SENTRY_RELEASE?.trim() || undefined,
    integrations: [
      Sentry.reactRouterV7BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.replayIntegration({ maskAllText: true, blockAllMedia: true }),
    ],
    tracesSampleRate: isProd ? 0.2 : 1.0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: isProd ? 0.25 : 0,
    tracePropagationTargets: ['localhost', /^https:\/\/api\.visime\.com/i],
    initialScope: (scope) => {
      scope.setTag('platform', 'web');
      return scope;
    },
    beforeSend(event) {
      const req = event.request;
      if (req?.headers) {
        delete req.headers.Authorization;
        delete req.headers.Cookie;
      }
      if (req?.url) {
        try {
          const u = new URL(req.url);
          u.search = '';
          req.url = u.toString();
        } catch {
          /* keep */
        }
      }
      return event;
    },
  });
}

export { Sentry };
